import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'sp-variant-images-delete-alert',
    templateUrl: './variant-images-delete-alert.component.html',
    styleUrls: ['./variant-images-delete-alert.component.scss'],
})
export class VariantImagesDeleteAlertComponent implements OnInit {
    @Output() closeDeleteEvent = new EventEmitter<void>();
    @Output() undoActionEvent = new EventEmitter<void>();

    constructor() {}

    ngOnInit(): void {}

    undoDeleteImage(): void {
        this.undoActionEvent.emit();
    }

    closeDeleteAlertSnackBar(): void {
        this.closeDeleteEvent.emit();
    }
}
